import { Link, Outlet, createFileRoute } from "@tanstack/react-router"

import { buttonVariants } from "@/components/ui/button"

export const Route = createFileRoute("/_authed/_admin/activity-levels")({
  component: ActivityLevelsLayout,
})

function ActivityLevelsLayout() {
  return (
    <div className="grid gap-4 md:gap-5">
      <nav
        aria-label="Activity Levels sections"
        className="flex flex-wrap gap-2"
      >
        <Link
          to="/activity-levels"
          activeOptions={{ exact: true }}
          className={buttonVariants({ variant: "outline" })}
          activeProps={{ className: buttonVariants({ variant: "default" }) }}
        >
          Tracks
        </Link>
        <Link
          to="/activity-levels/members"
          className={buttonVariants({ variant: "outline" })}
          activeProps={{ className: buttonVariants({ variant: "default" }) }}
        >
          Members
        </Link>
        <Link
          to="/activity-levels/leaderboard"
          className={buttonVariants({ variant: "outline" })}
          activeProps={{ className: buttonVariants({ variant: "default" }) }}
        >
          Leaderboard
        </Link>
        <Link
          to="/activity-levels/achievements"
          className={buttonVariants({ variant: "outline" })}
          activeProps={{ className: buttonVariants({ variant: "default" }) }}
        >
          Achievements
        </Link>
      </nav>
      <Outlet />
    </div>
  )
}
